import MultiSelectListbox from './components/MultiSelect/MultiSelect.vue';

export default MultiSelectListbox;
export { MultiSelectListbox };
